import globalStore from "@/store/global.store";
import {
  BANK_ACCOUNTS_STORE_INJECTION_KEY,
  GLOBAL_STORE_INJECTION_KEY,
  ONBOARDING_STATUS_STORE_INJECTION_KEY,
  BUSINESS_PHONE_VERIFICATION_STORE_INJECTION_KEY,
} from "@/store/keys";
import onboardingStatusStore from '@/store/onboarding.store';
import bankAccountsStore from "./store/bank-accounts.store";
import businessPhoneVerificationStore from "./store/business-phone-verification.store";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
// @ts-expect-error missing declaration file
import vClickOutside from "click-outside-vue3"; 
import { vMaska } from "maska";
import { createApp } from 'vue';
import { initSentry } from "./config/sentry";
import { createPinia } from 'pinia';

import "../node_modules/vue3-toggle-button/dist/style.css";
import App from './App.vue';
import auth0 from "./lib/auth0";
import router from "./router";

const app = createApp(App);
const pinia = createPinia();

app.provide(GLOBAL_STORE_INJECTION_KEY, globalStore);
app.provide(ONBOARDING_STATUS_STORE_INJECTION_KEY, onboardingStatusStore);
app.provide(BANK_ACCOUNTS_STORE_INJECTION_KEY, bankAccountsStore);
app.provide(BUSINESS_PHONE_VERIFICATION_STORE_INJECTION_KEY, businessPhoneVerificationStore);

app.directive("maska", vMaska);

initSentry(app);

app.use(router);
app.use(auth0);
app.use(Antd);
app.use(pinia);
app.use(vClickOutside);

app.mount("#app");

